import { first } from 'lodash';
import { useMemo } from 'react';

import { useFeedback } from '@/components/notifications/Feedback/useFeedback';
import { useReportError } from '@/hooks/useReportError';
import { getNodes } from '@/utils/graphqlUtils';

import { useDsueFormQuery } from '../graphql/DSUEForm.generated';

const errorMessage = 'Error fetching DSUE data';

export function useDSUEData(householdId: string) {
  const { reportError } = useReportError();
  const { showFeedback } = useFeedback();

  const queryProps = useDsueFormQuery({
    fetchPolicy: 'network-only',
    variables: {
      householdWhereInput: {
        id: householdId,
      },
    },
    onError: (error) => {
      reportError(errorMessage, error);
      showFeedback(errorMessage);
    },
  });

  const household = first(getNodes(queryProps.data?.households));

  const clientData = useMemo(() => {
    return household?.possiblePrimaryClients.map((client) => {
      return client;
    });
  }, [household]);

  return {
    ...queryProps,
    household,
    clientData,
  };
}
